import dynamic from 'next/dynamic'
import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import CallToActions from '../../components/common/CallToActions'
import Seo from '../../components/common/Seo'
import DefaultHeader from '../../components/header/header-rslhome'
import DefaultFooter from '../../components/footer/footer-3'
import Overview from '../../components/hotel-single/OverviewTour'
import ModalVideo from 'react-modal-video'
import { Gallery, Item } from 'react-photoswipe-gallery'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper'
import { useMediaQuery } from 'react-responsive'
import Link from 'next/link'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'

import LocationTopBar from '../../components/common/LocationTopBarHoliday'
import Categories from '../../components/destinations/components/CategoriesStaycation'
import { CircularProgress } from '@mui/material'
import { getStaycationDetail } from '../../redux/slices/staycation'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import 'photoswipe/dist/photoswipe.css'
import { dispatch, useSelector } from '../../redux/store'
import BusRentalCalanderFrom from '../../components/hero/hero-rslhome/bus/DetailsCalender'
import GuestSearch from '../../components/rental-list/common/GuestAndRooms'
import moment from 'moment'
import Skeleton from '@mui/material/Skeleton'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import GoogleMap from '../../components/staycations/googleMap';
import RelatedProducts from '../../components/destinations/RelatedProducts'
import { fetchSeoByPage } from '../../lib/seoHelper'

const Destinations = ({ meta }) => {
  const router = useRouter()
  const divRef = useRef()
  const { staycationDetail } = useSelector(state => state.staycation)
  const [holidayData, setHolidayData] = useState(null)
  const [changeDate, setChangeDate] = useState(false)
  const [open, setOpen] = useState(true)
  // const [checkInDate, setCheckInDate] = useState('Please select');
  const [checkInDate, setCheckInDate] = useState(null)
  const [checkOutDate, setCheckOutDate] = useState(null)
  const [multiImage, setMultiImage] = useState([])
  const [loader, setLoader] = useState(false)
  const [childAge, setChildAge] = useState([])
  const isMobileOrTablet = useMediaQuery({ maxWidth: 1024 })
  const [imageSize, setImageSize] = useState({ width: 1000, height: 1000 })

  const [guetsValue, setGuestValue] = useState({
    Adults: 1,
    Children: 0,
    Rooms: 1,
    childrenAges: []
  })

  const [additionalCounters, setAdditionalCounters] = useState([
    {
      name: 1,
      adults: 1,
      children: 0,
      childrenAges: [],
      Rooms: 1
    }
  ])

  const apiKey = process.env.MAPKEY;

  const {
    _id,
    country,
    city,
    checkIn,
    checkOut,
    adult,
    child,
    currency,
    room
  } = router.query

  useEffect(() => {
    if (_id) {
      dispatch(getStaycationDetail({ id: _id }))
    }
  }, [_id])

  useEffect(() => {
    if (staycationDetail) {
      setHolidayData(staycationDetail)
    }
  }, [staycationDetail])

  useEffect(() => {
    if (staycationDetail) {
      setLoader(true)
      if (Object.keys(staycationDetail).length === 0) {
      } else {
        setHolidayData(staycationDetail)
        setMultiImage(staycationDetail?.backgroundImage)
        setLoader(false)
      }
    }
    return () => { }
  }, [staycationDetail])

  const focusDiv = () => {
    if (divRef.current) {
      divRef.current.focus()
    }
  }

  const [showError, setShowError] = useState(false)

  const handleButtonClick = () => {
    setLoader(false);

    if (checkOutDate && checkInDate && checkOutDate !== '' && checkInDate !== '') {
      setShowError(false)
      setLoader(true)
      router.push({
        pathname: `/staycation/booking-page`,
        query: {
          packageId: _id,
          country: country,
          city: city,
          checkIn: moment(checkInDate).format?.('YYYY-MM-DD'),
          checkOut: moment(checkOutDate).format?.('YYYY-MM-DD'),
          checkInTime: holidayData?.checkInTime,
          checkOutTime: holidayData?.checkOutTime,
          adult: adult,
          child: child,
          currency: holidayData?.currency,
          roomCount: guetsValue?.Rooms,
          room: room,
          dayCount: numberOfDays,
          nights: numberOfDays ? numberOfDays : holidayData?.totalNights,
          packageName: holidayData?.packageName,
          cityName: holidayData?.cityName,
          vendorId: holidayData?.vendorInfo?._id,
          price: calculateTotalPrice()
            ? calculateTotalPrice()
            : holidayData?.price,
          packageImage: holidayData?.backgroundImage[0],
          vat: holidayData?.vat,
          originalPrice: calculateTotalOriginalPrice()
            ? calculateTotalOriginalPrice()
            : holidayData?.originalPrice,
          extraCharge: holidayData?.extraCharge,
          additionalCounters: JSON.stringify(additionalCounters),
          rating: holidayData?.rating,
          reviews: holidayData?.reviews,
          defaultNights: holidayData?.totalNights,
          defaultPrice: holidayData?.price
        }
      })
    } else {
      // setShowError(true);
      focusDiv()
      setChangeDate(true)
      setOpen(true)
    }
  }

  const startDate = new Date(checkInDate)
  const endDate = new Date(checkOutDate)
  const oneDay = 24 * 60 * 60 * 1000
  const numberOfDays = Math.max(1, Math.round(Math.abs((startDate - endDate) / oneDay)));

  const calculateTotalPrice = () => {
    if (checkInDate && checkOutDate) {
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      const startDate = new Date(checkInDate)
      const endDate = new Date(checkOutDate)
      console.log("calculateTotalPrice -->", startDate, endDate, oneDay)
      // const numberOfDays = Math.round(Math.abs((startDate - endDate) / oneDay))
      const numberOfDays = Math.max(1, Math.round(Math.abs((startDate - endDate) / oneDay)));

      const priceForTotalNights = holidayData?.price || 0
      const totalNights = parseInt(holidayData?.totalNights) || 1
      const roomCount = additionalCounters.length || 0

      console.log("calculateTotalPrice 1", numberOfDays, totalNights)

      const multiplier = Math.ceil(numberOfDays / totalNights)

      console.log("calculateTotalPrice", priceForTotalNights, roomCount, multiplier)
      const totalPrice = priceForTotalNights * roomCount * multiplier

      return totalPrice.toFixed(2);
    }

    return 0
  };

  const calculateTotalOriginalPrice = () => {
    if (checkInDate && checkOutDate) {
      const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      const startDate = new Date(checkInDate)
      const endDate = new Date(checkOutDate)
      const numberOfDays = Math.max(1, Math.round(Math.abs((startDate - endDate) / oneDay)));

      const priceForTotalNights = holidayData?.originalPrice || 0
      const totalNights = parseInt(holidayData?.totalNights) || 1
      const roomCount = additionalCounters.length || 0

      const multiplier = Math.ceil(numberOfDays / totalNights)
      return priceForTotalNights * roomCount * multiplier
    }

    return 0
  }
  const [isOpen, setIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)

  const handleOpen = index => {
    setPhotoIndex(index)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleNext = () => {
    setPhotoIndex((photoIndex + 1) % multiImage.length) // Loop to first image after last
  }

  const handlePrev = () => {
    setPhotoIndex((photoIndex + multiImage.length - 1) % multiImage.length) // Loop to last image before first
  }

  const handleImageLoad = event => {
    setImageSize({
      width: event.target.naturalWidth,
      height: event.target.naturalHeight
    })
  }

  return (
    <>
      <Seo meta={meta} />
      {/* End Page Title */}

      <div className='header-margin'></div>
      {/* header top margin */}

      <DefaultHeader />
      {/* End Header 1 */}

      {/* <LocationTopBar /> */}
      {/* End location top bar section */}
      <section className='pt-60 mt-60'>
        <div className='container'>
          {loader ?
            <div className='d-flex justify-content-between'>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" width="100%" height={40} />
                <Skeleton variant="text" width="100%" height={150} />
              </div>
              <div>
                <Skeleton variant="text" width={120} height={30} />
                <Skeleton variant="rectangular" width={120} height={20} />
              </div>
            </div>
            :
            <div className='row y-gap-20 justify-between justify-content-md-start items-start'>
              <div className='col-12 col-md-8'>
                <div className='row x-gap-20  items-center'>
                  <div className='col-auto'>
                    <h1 className='text-30 sm:text-25 fw-600'>
                      {holidayData?.packageName}
                    </h1>
                  </div>
                  {/* End .col */}
                </div>
                {/* End .row */}

                <div className='row x-gap-20 y-gap-20 items-center'>
                  <div className='col-auto'>
                    <div className='d-flex items-center text-15 text-light-1'>
                      {/* <i className="icon-location-2 text-16 mr-5" /> */}
                      {holidayData?.description}
                    </div>
                  </div>
                </div>
                {/* End .row */}
              </div>
              {/* End .col */}

              <div className='col-12 col-md-4'>
                <div className='col items-start'>
                  <div className='col-auto justify-content-end align-items-start align-items-md-end d-flex flex-column'>
                    <div className='text-14 text-dark-1 text-secondary'>
                      From
                      <span className='text-26 px-2 text-dark-1 fw-600'>
                        {holidayData?.currency} {holidayData?.price}
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: '14px',
                          color: 'black',
                          fontWeight: 'lighter',
                          marginRight: '6px'
                        }}
                      >
                        {/* {"2 Persons"} */}
                      </span>
                      {Array.from(
                        {
                          length:
                            holidayData?.rating > 5 ? 5 : holidayData?.rating
                        },
                        (_, index) => (
                          <i
                            key={index}
                            className='icon-star text-10 text-yellow-1'
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* End .col */}
            </div>
          }
          {/* End .row */}
          {loader ? (
            <Gallery>
              <div className='galleryGrid -type-1 pt-30'>
                <div className='galleryGrid__item relative d-flex'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width='100%'
                    height={310}
                  />
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width='100%'
                    height={150}
                  />
                </div>

                <div className='galleryGrid__item'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width='100%'
                    height={150}
                  />
                </div>

                <div className='galleryGrid__item'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width='100%'
                    height={150}
                  />
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative d-flex'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width='100%'
                    height={150}
                  />
                </div>
                {/* End .galleryGrid__item */}
              </div>
            </Gallery>
          ) : isMobileOrTablet ? (
            <Swiper
              spaceBetween={10}
              slidesPerView={1}
              autoplay={true}
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: '.js-destination-next',
                prevEl: '.js-destination-prev'
              }}
            >
              {multiImage.map((image, index) => (
                <SwiperSlide key={index}>
                  {image ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${image}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${image}`}
                      width={imageSize.width}
                      height={imageSize.height}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={() => handleOpen(index)}
                          src={`${process.env.IMAGE_BASE_URL}/${image}`}
                          alt={`image-${index}`}
                          className='rounded-4'
                          style={{ width: '100%', height: '100%' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    <Skeleton variant='rect' width='100%' height={310} />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Gallery>
              <div className='galleryGrid -type-1 pt-30'>
                <div className='galleryGrid__item relative d-flex'>
                  {multiImage[0] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[0]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[0]}`}
                      width={imageSize.width}
                      height={imageSize.height}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[0]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '660px', height: '460px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={500} height={310} />
                  )}
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative'>
                  {multiImage[1] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[1]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[1]}`}
                      width={imageSize.width}
                      height={imageSize.height}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[1]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '325px', height: '225px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>

                <div className='galleryGrid__item relative'>
                  {multiImage[2] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[2]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[2]}`}
                      width={imageSize.width}
                      height={imageSize.height}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[2]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '325px', height: '225px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>

                <div className='galleryGrid__item relative'>
                  {multiImage[3] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[3]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[3]}`}
                      width={imageSize.width}
                      height={imageSize.height}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[3]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '325px', height: '225px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative d-flex'>
                  {multiImage[4] ? (
                    <>
                      <Item
                        original={`${process.env.IMAGE_BASE_URL}/${multiImage[4]}`}
                        thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[4]}`}
                        width={imageSize.width}
                        height={imageSize.height}
                      >
                        {({ ref, open }) => (
                          <img
                            ref={ref}
                            onClick={open}
                            src={`${process.env.IMAGE_BASE_URL}/${multiImage[4]}`}
                            alt='image'
                            className='rounded-4'
                            style={{ width: '325px', height: '225px' }}
                            role='button'
                            onLoad={handleImageLoad}
                          />
                        )}
                      </Item>
                    </>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>
                {/* End .galleryGrid__item */}
              </div>
            </Gallery>
          )}

          {isOpen && (
            <div className='modal'>
              <div className='modal-content'>
                <span className='close' onClick={handleClose}>
                  &times;
                </span>
                <img
                  src={`${process.env.IMAGE_BASE_URL}/${multiImage[photoIndex]}`}
                  alt={`image-${photoIndex}`}
                  style={{ width: '100%', height: 'auto' }}
                />

                <div className='nav-buttons'>
                  <button
                    onClick={handlePrev}
                    className='buttonStyles nav-left'
                  >
                    &lt;
                  </button>
                  <button
                    onClick={handleNext}
                    className='buttonStyles nav-right'
                  >
                    &gt;
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* End .container */}
      </section>

      <section className='layout-pb-md pt-20'>
        <div className='container'>
          <div className='row x-gap-50 y-gap-20 items-center pt-20 pb- item_gap-x10'>
            <Categories catContent={holidayData?.amenities} />
          </div>
        </div>
      </section>

      <Box className='container pt-30 pb-60' id='sidebar'>
        <Box className='row'>
          <Box component='div' className='col-xl-8'>
            <section className='pt-0' style={{ minHeight: '100vh' }}>
              <section className='layout-pb-md'>
                <div className='container'>
                  <div className='row'>
                    <div className='col-auto'>
                      <div className='row x-gap-20 y-gap-20 items-center item_gap-x10'>
                        <h4>{holidayData?.packageName}</h4>
                        <p>{holidayData?.description}</p>
                      </div>

                      {/* End .row */}
                      <h4
                        className='text-22 fw-700 mt-40 mb-20'
                        style={{
                          borderTop: '1px solid #D0E7D2',
                          padding: '20px 0'
                        }}
                      >
                        Details
                      </h4>
                      <div id='overview' className='col-12 '>
                        <Overview
                          holidayData={holidayData?.staycationsDescription}
                        />
                      </div>
                      <div id='overview' className='col-12'>
                        <Overview holidayData={holidayData?.highlights} />
                      </div>
                    </div>
                  </div>
                </div>
                {/* End .container */}
              </section>
              {/* End Top Banner,categorie,intro,weather, generic info section */}

              {holidayData?.detailInfo?.filter(
                item =>
                  item.title.trim() !== '' && item.description.trim() !== ''
              ).length > 0 ? (
                <section className='' id='facilities'>
                  <div className='container'>
                    <div className='row x-gap-40 y-gap-40'>
                      <div className='col-12'>
                        <h3 className='text-22 fw-500 mb-20'>
                          {holidayData?.detailInfoTitle}
                        </h3>
                        {holidayData?.detailInfo
                          .filter(
                            item =>
                              item.title.trim() !== '' &&
                              item.description.trim() !== ''
                          )
                          .map((item, index) => (
                            <Accordion
                              defaultExpanded={index === 0}
                              key={item.id}
                              sx={{
                                boxShadow: 'none',
                                borderWidth: '0',
                                '&.Mui-expanded': {
                                  margin: '0px !important'
                                }
                              }}
                            >
                              <AccordionSummary
                                sx={{
                                  padding: '0px'
                                }}
                                expandIcon={<ExpandMoreIcon />}
                              >
                                <h6 className='py-1 text-dark'>{item.title}</h6>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div
                                  className='ql-editor'
                                  dangerouslySetInnerHTML={{
                                    __html: item.description
                                  }}
                                />
                              </AccordionDetails>
                            </Accordion>
                          ))}
                      </div>
                    </div>
                  </div>
                </section>
              ) : null}

              {holidayData?.latitude && holidayData?.longitude ? (<section className='mb-20' id='facilities'>
                <div className='container'>
                  <div className='row x-gap-40 y-gap-40'>
                    <div className='col-12'>
                      <h3 className='text-22 fw-500 mb-20'>Location</h3>
                      <GoogleMap
                        apiKey={apiKey}
                        name={holidayData?.name}
                        latitude={holidayData?.latitude}
                        longitude={holidayData?.longitude}
                      />
                    </div>
                  </div>
                </div>
              </section>
              ) : (
                ''
              )}
            </section>
          </Box>

          <Box
            component='div'
            className='col-xl-4 col-sm-12 py-2 sticky-sidebar position-static scrollbar-width-none'
          >
            <Box
              className='lg:ml-0 mx-20 rounded'
              sx={{
                border: '1px solid #0000001f',
                padding: '15px'
              }}
              id='selectDate'
              ref={divRef}
              tabIndex={0}
              aria-label='Focus Div'
              onClick={focusDiv}
            >
              <div className='staycation-price-detail'>
                <span
                  className='font-weight-light'
                  style={{
                    fontSize: '14px',
                    color: 'black',
                    fontWeight: 'lighter',
                    marginRight: '8px'
                  }}
                >
                  From
                </span>
                <div className='price'>
                  {holidayData?.currency && holidayData?.currency !== ''
                    ? holidayData?.currency.toUpperCase()
                    : holidayData?.currency}{' '}
                  {holidayData?.price}{' '}
                  {Number(holidayData?.originalPrice) >
                    Number(holidayData?.price) && (
                      <span className='price-strike'>
                        {holidayData?.currency}{' '}
                        {Number(holidayData?.originalPrice)}
                      </span>
                    )}
                </div>
              </div>
              <Divider
                className='my-2'
                sx={{
                  borderColor: 'grey !important'
                }}
              />

              <div className='mt-md-0'>
                <h4 className='my-3'>Personalize Your Stay</h4>
                <div className='my-3'>
                  <GuestSearch
                    customBorder="border rounded py-1"
                    additionalCounters={additionalCounters}
                    setAdditionalCounters={setAdditionalCounters}
                    holidayData={holidayData}
                    setGuestValue={setGuestValue}
                    guetsValue={guetsValue}
                    setChildAge={setChildAge}
                    childAge={childAge}
                  />
                </div>
                <div
                  className='border d-flex justify-between items-center align-center my-3'
                  style={{
                    padding: '6px 12px',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      fontSize: '20px',
                      // color: '#ffffff',
                      color: '#000000',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <h6 className='mr-5'>
                      {' '}
                      {checkInDate ? checkInDate : 'Check In'}
                    </h6>
                    /<h6 className="ml-5"> {checkOutDate ? checkOutDate : 'Check Out '}</h6>
                    {/* <CalendarMonthIcon /> */}
                  </div>
                  <h6
                    className='staycation-change bg-light-4 text-light-1'
                    style={{
                      // backgroundColor: 'black',
                      padding: '5px 5px',
                      borderRadius: '6px',

                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setChangeDate(true)
                      setOpen(true)
                    }}
                  >
                    {/* Select Date */}

                    <CalendarMonthIcon />
                  </h6>
                </div>
                {changeDate ? (
                  <>
                    <BusRentalCalanderFrom
                      setOpen={setOpen}
                      open={open}
                      // setCheckInDate={setCheckInDate}
                      setCheckInDate={setCheckInDate}
                      setCheckOutDate={setCheckOutDate}
                      checkInDate={checkInDate}
                      checkOutDate={checkOutDate}
                      holidayData={holidayData}
                      changeDate={changeDate}
                      setChangeDate={setChangeDate}
                    />
                  </>
                ) : (
                  ''
                )}

                <h6 className='my-3'>
                  Total Amount for {numberOfDays || ''} Days:{' '}
                  {checkInDate && checkOutDate ? calculateTotalPrice() : ''}
                </h6>
              </div>

              <div className='col-md-12'>
                <div
                  style={{
                    marginTop: '24px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                  }}
                >
                  <button
                    onClick={handleButtonClick}
                    style={{ width: '120px', fontSize: '17px' }}
                    className='bg-dark-3 rounded-4 -dark-4 py-5 bg-dark-3 text-white '
                  >
                    {loader ? <CircularProgress size={20} /> : 'Book Now'}
                  </button>
                </div>
              </div>
            </Box>
          </Box>
        </Box>
      </Box>

      <section className='container'>
        <div className='col-auto'>
          <Divider
            sx={{
              borderColor: 'grey !important'
            }}
          />
        </div>
      </section>

      <section className='layout-pb-md sm-px-3'>
        <div className='container'>
          <div className='col-auto'>
            <div className='sectionTitle -md'>
              <h2 className='rsl_title'>Related Staycations</h2>
              <p className='sub-header'>
                Explore cozy retreats and stunning escapes, crafted for your perfect staycation.
              </p>
            </div>
          </div>

          <div className='row y-gap-30 pt-20'>
            <div
              className='relative'
              style={{
                overflow: 'hidden'
              }}
            >
              <RelatedProducts serviceType={4} type={holidayData?.totalNights} />
            </div>
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>

      <CallToActions />
      {/* End Call To Actions Section */}

      <DefaultFooter />
      {/* End Call To Actions Section */}
    </>
  )
}

// export default dynamic(() => Promise.resolve(Destinations), { ssr: false })

export default Destinations;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}